import { useIsTablet } from "@/config/hooks";
import { Button } from "@fluentui/react-components";
import { PspButtonProps } from "./PspButton.types";
import { PropsWithChildren } from "react";
import { clsx } from "clsx/lite";

export default function PspButton({
  disabled,
  onClick,
  children,
  size,
  appearance = "secondary",
  className,
  customRef,
  icon,
}: PropsWithChildren<PspButtonProps>) {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const isTablet = useIsTablet();

  // -----------------------------------------------------------------------------
  // COMPONENTS
  // -----------------------------------------------------------------------------

  return (
    <>
      {isTablet ? (
        <div className={className}>
          <Button
            size={size}
            disabled={disabled}
            onClick={onClick}
            appearance={appearance}
            ref={isTablet ? customRef : undefined}
            // @ts-expect-error can't be bothered to add the correct type for this
            icon={icon}
          >
            {children}
          </Button>
        </div>
      ) : (
        <button
          disabled={disabled}
          onClick={onClick}
          ref={isTablet ? undefined : customRef}
          className={clsx(
            "tablet:hidden",
            "font-bold",
            "text-base",
            "w-full",
            "h-12",
            "px-8",
            "flex",
            "justify-center",
            "items-center",
            "rounded-xl",
            "duration-200",
            "ease-in-out",
            "line-clamp-1",
            className,
            disabled && appearance === "primary"
              ? "opacity-25"
              : disabled && appearance === "secondary" && "opacity-40",
            appearance === "primary"
              ? "bg-primary active:bg-primary-pressed text-font-white"
              : appearance === "secondary" &&
                  `
                  bg-neutral
                  active:bg-canvas-secondary
                  ${disabled ? "text-disabled" : "text-font-black"}`,
          )}
        >
          <div className="flex flex-row items-center gap-2">
            {icon}
            {children}
          </div>
        </button>
      )}
    </>
  );
}
